import { useClient } from "../../api/useClient";

export function useActiveApp() {
    const client = useClient();
    const apps = client.useAllApps().apps;
    const sortedApps = apps.sort((a, b) => a.name.localeCompare(b.name))
    const activeApps = sortedApps.filter(app => app.active)
    return activeApps[0];
}